const initial = {
    loading: false,
    error: null,
};
export const reducer = (state = initial, action) => {
    switch (action.type) {
        case 'UPDATE_ACCOUNT__REQUEST':
        case 'DELETE_ACCOUNT__REQUEST':
        case 'SAVE_UI_SETTINGS__REQUEST':
            return { ...state, loading: true };
        case 'STOP_LOADING_ACCOUNT_DIALOG':
            return { ...state, loading: false };
        case 'CLEAR_ERROR_ACCOUNT_DIALOG':
            return { ...state, error: null };
        case 'DELETE_ACCOUNT__OK':
            return { ...state, loading: false, error: null };
        case 'DELETE_ACCOUNT__FAIL':
        case 'UPDATE_ACCOUNT__FAIL':
        case 'SAVE_UI_SETTINGS__FAIL':
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
};
export const AlienServiceReducer = (state = { archive_tasks: [], alien_tokens: [] }, action) => {
    switch (action.type) {
        case 'UPDATE_ARCHIVE_TASKS':
            return { ...state, archive_tasks: action.tasks };
        case 'UPDATE_ALIEN_TOKENS':
            return { ...state, alien_tokens: action.tokens };
        default:
            return state;
    }
};
